/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 12th 2022, 4:34:17 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`os-tabpanel-${index}`}
      aria-labelledby={`os-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `os-tab-${index}`,
    "aria-controls": `os-tabpanel-${index}`,
  };
}

interface OSTabsProps {
  tabLabels: React.ReactNode[];
  tabPanels: React.ReactNode[];
  tabsStyle?: React.CSSProperties;
}

export const OSTabs = ({ tabLabels, tabPanels, tabsStyle }: OSTabsProps) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex" }}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Tabs Component"
        sx={{ borderRight: 1, borderColor: "divider", ...tabsStyle }}
      >
        {tabLabels.map((tabLabel, index) => (
          <Tab label={tabLabel} {...a11yProps(index)} />
        ))}
      </Tabs>
      {tabPanels.map((tabPanel, index) => (
        <TabPanel value={value} index={index}>
          {tabPanel}
        </TabPanel>
      ))}
    </Box>
  );
};
